import React, { useEffect, useState, useMemo, useRef } from "react";
import {
  FlexRowBetween,
  FlexRowStart,
  GenericDiv,
  GuestCard,
  Input,
  Label,
  ListHolder,
  MediumFont,
  PlaceHolderImage,
  RespFont,
  TextWithPic,
} from "../common/Style";
import checkSign from "../../assets/common/checkSign.svg";
import clear from "../../assets/common/clear.svg";
import emojiNoMouth1 from "../../assets/common/emojiNoMouth1.svg";
import emojiSad1 from "../../assets/common/emojiSad1.svg";
import support from "../../assets/common/support.svg";
import bell from "../../assets/common/bell.svg";
import bellOrange from "../../assets/common/bellOrange.svg";
import bellOrange_bold from "../../assets/common/bellOrange1.svg";
import emojiSmile1 from "../../assets/common/emojiSmile1.svg";
import checklist from "../../assets/common/checklistM.svg";
import users from "../../assets/common/usersB.svg";
import callRed from "../../assets/common/callRed.svg";
import trashB from "../../assets/common/trashB.svg";
import closenessS2 from "../../assets/common/closenessS2.svg";
import weddingInvitation from "../../assets/common/weddingInvitation.svg";
import logout from "../../assets/common/logout.svg";
import GenericModal from "../common/modals/GenericModal";
import ToolsOptions from "./ToolsOptions";
import ClientRoutes from "../../navigation/Routes";
import { useHistory, useLocation } from "react-router-dom";
import FilledLoading from "../common/loader/FilledLoading";
import {
  cleanAll,
  deleteF,
  editGift,
  editMany,
  getAll,
  getById,
} from "../../store/reducers/guestsReducer";
import { sendGenericSms } from "../../store/reducers/dataReducer";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import {
  deactivateEvent,
  incrementFreeSmsUsage,
} from "../../store/reducers/authReducer";
import { cardcomCreateLinkForUserPayment } from "../../store/reducers/paymentsReducer";
import noPhone from "../../assets/common/noPhone.svg";
import ssketch from "../../assets/common/ssketch.svg";
import notes from "../../assets/common/notes.svg";
import sms from "../../assets/common/sms.svg";
import whatsapp from "../../assets/common/whatsapp.svg";
import shareIcon from "../../assets/common/shareIcon.svg";
import Edit from "./guests/Edit";
import AddManually from "./guests/AddManually";
import AddExcel from "./guests/AddExcel";
import AddIphone from "./guests/AddIphone";
import AddAndroid from "./guests/AddAndroid";
import LogoutSpecipic from "../common/LogOut/LogoutSpecipic";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import {
  addAlpha,
  compareWeddingExportFromArrayBuffer,
  exportToCSV,
  exportWeddingInvitationsTemplateForGuestList,
  exportWeddingInvitationsTemplateHeIL,
  handleClickScroll,
} from "../common/others/Functions";
import FilterBar from "../common/others/FilterBar";
import OpacityLoading from "../common/loader/OpacityLoading";
import YesNoModal from "../common/modals/YesNoModal";
import Closeness from "./guests/editMany/Closeness";
import WasInvited from "./guests/editMany/WasInvited";
import Connection from "./guests/editMany/Connection";
import Tables from "./guests/editMany/Tables";
import MainTables from "./tables/MainTables";
import Support from "./instruction/Support";
import Mis from "./guests/Mis";
import Gifts from "./instruction/Gifts";
import Dayalim from "./tables/Dayalim";
import ConnectionOtherEvent from "./guests/editMany/ConnectionOtherEvent";
import CanWeStart from "../common/modals/CanWeStart";
import AddList from "./guests/AddList";
import { useAccessibility } from "../../contexts/AccessibilityContext";
import UserPaymentSuccess from "../common/payments/UserPaymentSuccess";
import UserPaymentFailed from "../common/payments/UserPaymentFailed";

// קומפוננט תפריט בורגר
const BurgerMenu = ({
  isOpen,
  onToggle,
  children,
  position = "relative",
  top,
  left,
  showErrorDot = false,
}) => {
  return (
    <div
      style={{
        position: position,
        zIndex: 1000,
        ...(top && { top }),
        ...(left && { left }),
      }}
    >
      {/* כפתור הבורגר */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
        style={{
          background: "#fff",
          color: "white",
          border: "none",
          borderRadius: "0px 0px 12px 0px",
          padding: "10px 12px 12px 10px",
          // padding: "12px",
          cursor: "pointer",
          fontSize: 14,
          width: "44px",
          height: "44px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          transition: "all 0.3s ease",
          position: "relative",
        }}
        title="תפריט"
      >
        {showErrorDot && (
          <div
            style={{
              position: "absolute",
              top: "6px",
              right: "6px",
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              backgroundColor: "#ff9800",
              border: "2px solid #fff",
              zIndex: 1001,
              boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
            }}
          />
        )}
        <div
          style={{
            width: "23px",
            height: "2px",
            background: "#5377bb",
            position: "relative",
            transition: "all 0.3s ease",
            transform: isOpen ? "rotate(45deg)" : "none",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "-7px",
              left: "0",
              width: "100%",
              height: "100%",
              background: "#5377bb",
              transition: "all 0.3s ease",
              opacity: isOpen ? "0" : "1",
            }}
          />
          <div
            style={{
              position: "absolute",
              top: "7px",
              left: "0",
              width: "100%",
              height: "100%",
              background: "#5377bb",
              transition: "all 0.3s ease",
              transform: isOpen ? "rotate(-90deg)" : "none",
            }}
          />
        </div>
      </button>

      {/* תפריט נפתח */}
      {isOpen && (
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            position: "absolute",
            top: "44px",
            left: "0",
            background: "white",
            borderRadius: "12px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
            padding: "16px",
            minWidth: "200px",
            maxHeight: "80vh",
            overflowY: "auto",
            overflowX: "hidden",
            animation: "slideIn 0.3s ease",
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

// קומפוננט פריט תפריט
const MenuItem = ({
  icon,
  text,
  onClick,
  color = "#5377bb",
  disabled = false,
  showDot = false,
  animate = false,
  actionText = "",
  actionColor = "#5377bb",
}) => {
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) onClick();
      }}
      disabled={disabled}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        width: "100%",
        padding: "12px 16px",
        background: "transparent",
        border: "none",
        borderRadius: "8px",
        cursor: disabled ? "not-allowed" : "pointer",
        color: disabled ? "#999" : color,
        fontSize: "14px",
        fontWeight: "500",
        transition: "all 0.2s ease",
        opacity: disabled ? 0.6 : 1,
        animation: animate ? "pulse 1.5s ease-in-out infinite" : "none",
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.target.style.background = "#f8f9fa";
        }
      }}
      onMouseLeave={(e) => {
        e.target.style.background = "transparent";
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>{icon}</div>
      <span style={{ flex: 1, textAlign: "right", direction: "rtl" }}>
        {text}
      </span>
      {actionText ? (
        <span
          style={{
            fontSize: "12px",
            fontWeight: "700",
            color: actionColor,
            border: `1px solid ${actionColor}`,
            borderRadius: "999px",
            padding: "2px 8px",
            lineHeight: 1.6,
            flexShrink: 0,
          }}
        >
          {actionText}
        </span>
      ) : null}
      {showDot && (
        <div
          style={{
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            backgroundColor: "#ff9800",
            flexShrink: 0,
            marginRight: "4px",
          }}
        />
      )}
      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.6;
            }
          }
        `}
      </style>
    </button>
  );
};

let multyChoise = {};
let multyChoiseCounter = 0;
let phones = {};

const MainUser = () => {
  let widthS = window.innerWidth; // 1728

  const dispatch = useDispatch();
  const { user, isTal } = useSelector((state) => state.authReducer);
  const isEventActive = user?.isReady === true;
  const canSeeUnpaidGuestsNotice = user?.role === 5;
  const FREE_GUEST_SMS_LIMIT = 2;
  const freeSmsUsedCount = Number(user?.freeSMS ?? 0);
  const isGuestBulkSmsBlocked = freeSmsUsedCount >= FREE_GUEST_SMS_LIMIT;
  const { openPanel: openAccessibilityPanel, enabled: accessibilityEnabled } =
    useAccessibility();
  const { guests, guestsLoading } = useSelector((state) => state.guestsReducer);
  let history = useHistory();
  const location = useLocation();
  const [giftMode, setGiftMode] = useState(false);
  // const [multyChoise, setMultyChoise] = useState({});
  // const [multyChoiseCounter, setMultyChoiseCounter] = useState(0);
  const [tempGift, setTempGift] = useState(0);
  const [showHadrahot, setShowHadrahot] = useState(false);
  const [showReports, setShowReports] = useState(false);
  const [showDups, setShowDups] = useState([]);
  const [showMenu, setShowMenu] = useState(false);
  const [isMainMenuBurgerOpen, setIsMainMenuBurgerOpen] = useState(false);
  const [showLogout, setShowLogout] = useState(false);
  const [showIsReadyConfirm, setShowIsReadyConfirm] = useState(false);
  const [showAddOptions, setShowAddOptions] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [showEditGuest, setShowEditGuest] = useState(false);
  const [showAddManually, setShowAddManually] = useState(false);
  const [showAddExcel, setShowAddExcel] = useState(false);
  const [showAddIphone, setShowAddIphone] = useState(false);
  const [showList, setShowList] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showSendMessageModal, setShowSendMessageModal] = useState(false);
  const [showSystemNoticeModal, setShowSystemNoticeModal] = useState(false);
  const [sendMessageContent, setSendMessageContent] = useState("");
  const [showNoPhone, setShowNoPhone] = useState(false);
  const [showClosenessChange, setShowClosenessChange] = useState(false);
  const [showSupportModal, setShowSupportModal] = useState(false);
  const [showBalancesModal, setShowBalancesModal] = useState(false);
  const [expandSmsPurchase, setExpandSmsPurchase] = useState(false);
  const [expandWhaPurchase, setExpandWhaPurchase] = useState(false);
  const [smsPurchaseQty, setSmsPurchaseQty] = useState(0);
  const [whaPurchaseQty, setWhaPurchaseQty] = useState(0);
  const [showGifts, setShowGifts] = useState(false);
  const [showIplanModal, setShowIplanModal] = useState(false);
  const [showWeddingCompareModal, setShowWeddingCompareModal] = useState(false);
  const [weddingCompareLines, setWeddingCompareLines] = useState([]);
  const [weddingCompareNewGuests, setWeddingCompareNewGuests] = useState([]);

  const SMS_AGOROT = 8;
  const WA_AGOROT = 25;
  const qtyBtnStyle = {
    padding: "3px 8px",
    borderRadius: 6,
    border: "1px solid #ddd",
    background: "#f0f0f0",
    cursor: "pointer",
    fontSize: 13,
    fontWeight: 600,
  };

  const handleProceedToPayment = async () => {
    if (!user?._id || !user?.phone) {
      toast.error("חסרים פרטי משתמש ליצירת קישור תשלום");
      return;
    }
    if (unpaidGuestsCount <= 0) {
      toast.warning("לא נמצאו רשומות לתשלום");
      return;
    }
    setCreatingSystemPaymentLink(true);
    const res = await dispatch(
      cardcomCreateLinkForUserPayment({
        amount: unpaidGuestsCount,
        uid: user._id,
        phone: user.phone,
      }),
    );
    setCreatingSystemPaymentLink(false);

    const maybeLink =
      typeof res?.payload === "string"
        ? res.payload
        : typeof res?.payload?.link === "string"
          ? res.payload.link
          : typeof res?.payload?.url === "string"
            ? res.payload.url
            : "";
    if (maybeLink && /^https?:\/\//i.test(maybeLink)) {
      setSystemPaymentLink(maybeLink);
      return;
    }
    toast.error(res?.payload?.error || "יצירת קישור תשלום נכשלה");
  };

  const [showMisModal, setShowMisModal] = useState(false);
  const [showTablesChange, setShowTablesChange] = useState(false);
  const [showOwcChange, setShowOwcChange] = useState(false);
  const [showOwcOtherEventTypeChange, setShowOwcOtherEventTypeChange] =
    useState(false);
  const [showWasInvited, setShowWasInvited] = useState(false);
  const [showAddAndroid, setShowAddAndroid] = useState(false);
  const [what2show, setWhat2show] = useState("הוזמנו");
  const [categories, setCategories] = useState([]);
  const [cats, setCats] = useState();
  const [searchText, setSearchText] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [showAllCategories, setShowAllCategories] = useState(true);
  const [isCategoriesDropdownOpen, setIsCategoriesDropdownOpen] =
    useState(false);
  const categoriesDropdownRef = useRef(null);
  const categoriesButtonRef = useRef(null);
  const inputRef = useRef();
  const inputGiftRef = useRef();
  const weddingCompareFileInputRef = useRef(null);
  const [selected, setSelected] = useState(0);
  const [multiSelect, setMultiSelect] = useState(false);
  const [showOpts, setShowOpts] = useState(false);
  const [closenessChosenFlag, setClosenessChosenFlag] = useState(false);
  const [showtables, setShowtables] = useState(false);
  const [showDayalim, setShowDayalim] = useState(false);
  const [bellAnimate, setBellAnimate] = useState(false);
  const [unpaidGuestsCount, setUnpaidGuestsCount] = useState(0);
  const [unpaidGuestsNames, setUnpaidGuestsNames] = useState([]);
  const [showUnpaidGuestsList, setShowUnpaidGuestsList] = useState(false);
  const [systemPaymentLink, setSystemPaymentLink] = useState("");
  const [creatingSystemPaymentLink, setCreatingSystemPaymentLink] =
    useState(false);

  // PWA install – only in menu, no popup
  const [pwaDeferredPrompt, setPwaDeferredPrompt] = useState(null);
  const [pwaIsIOS, setPwaIsIOS] = useState(false);
  const [pwaStandalone, setPwaStandalone] = useState(false);
  const canShowInstallPwa = !pwaStandalone && (pwaDeferredPrompt || pwaIsIOS);

  useEffect(() => {
    setPwaStandalone(
      window.matchMedia("(display-mode: standalone)").matches ||
        window.navigator.standalone === true,
    );
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
    setPwaIsIOS(isIOS);
    const handler = (e) => {
      e.preventDefault();
      setPwaDeferredPrompt(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstallPwa = async () => {
    if (pwaDeferredPrompt) {
      pwaDeferredPrompt.prompt();
      const { outcome } = await pwaDeferredPrompt.userChoice;
      if (outcome === "accepted") setPwaDeferredPrompt(null);
      setIsMainMenuBurgerOpen(false);
    } else if (pwaIsIOS) {
      toast.info(
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "4px",
          }}
        >
          להורדת האפליקציה: לחץ על כפתור השיתוף{" "}
          <img
            src={shareIcon}
            alt="כפתור שיתוף"
            style={{
              width: 22,
              height: 22,
              verticalAlign: "middle",
              display: "inline-block",
            }}
          />{" "}
          בדפדפן ולאחר מכן "הוספה למסך הבית"
        </span>,
        { autoClose: 12000 },
      );
      setIsMainMenuBurgerOpen(false);
    }
  };

  const handleGetAll = async () => {
    setCats();
    dispatch(getAll()).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
    });
  };

  // const commonInit = (func) => {
  //   setMultyChoise({});
  //   setMultyChoiseCounter(0);
  //   setSelected(0);
  //   func(false);
  //   setMultiSelect(false);
  //   toast.success("הפעולה בוצעה בהצלחה");
  // };
  const commonInit = (func) => {
    multyChoise = {};
    multyChoiseCounter = 0;
    setSelected(0);
    func(false);
    setMultiSelect(false);
    toast.success("הפעולה בוצעה בהצלחה");
  };

  // Close categories dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        categoriesDropdownRef.current &&
        !categoriesDropdownRef.current.contains(event.target) &&
        categoriesButtonRef.current &&
        !categoriesButtonRef.current.contains(event.target)
      ) {
        setIsCategoriesDropdownOpen(false);
      }
    };

    if (isCategoriesDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isCategoriesDropdownOpen]);

  const handleShowDups = () => {
    if (showDups.length)
      toast.warning(
        `קיימת כפילות עבור המספר הבא: ${showDups[0]}\nיש להזין אותו בחיפוש ולתקן`,
        {
          autoClose: 20000,
          closeOnClick: true,
        },
      );
    else toast.success("אין כפולים 🙂");
  };

  const handleDeleteMany = async () => {
    if (Object.keys(multyChoise).length) {
      setShowLoading(true);
      dispatch(deleteF(Object.keys(multyChoise))).then((res) => {
        setShowLoading(false);
        if (res.payload?.error) toast.error(res.payload?.error);
        else commonInit(setShowDelete);
      });
    } else toast.warning("לא נבחרו רשומות");
  };

  const handleGoHadrahot = async () => {
    history.push(ClientRoutes.User.instruction);
  };
  const handleEditMany = async (body, init) => {
    if (Object.keys(multyChoise).length) {
      setShowLoading(true);
      dispatch(editMany({ ids: Object.keys(multyChoise), ...body })).then(
        (res) => {
          if (res.payload?.error) toast.error(res.payload?.error);
          else commonInit(init);
          setShowLoading(false);
        },
      );
    } else toast.warning("לא נבחרו רשומות");
  };

  useEffect(() => {
    handleGetAll();
    // return () => {
    //   dispatch(cleanAll());
    // };
  }, []);

  useEffect(() => {
    if (!user.isReady) setShowHadrahot(true);
  }, []);

  useEffect(() => {
    if (!isEventActive) {
      setShowSystemNoticeModal(false);
      setSystemPaymentLink("");
    }
  }, [isEventActive]);

  // בדיקת אורחים unpaid בכניסה ולאחר כל שינוי ברשימה (כולל הוספת אורחים)
  useEffect(() => {
    if (!canSeeUnpaidGuestsNotice) {
      setUnpaidGuestsCount(0);
      setUnpaidGuestsNames([]);
      setShowUnpaidGuestsList(false);
      return;
    }
    const guestsList = Array.isArray(guests)
      ? guests
      : Object.values(guests || {});
    const unpaidGuests = guestsList.filter((guest) => {
      const phone = guest?.phone;
      const hasPhone = phone != null && String(phone).trim() !== "";
      return (
        hasPhone &&
        Number(guest?.smsSent ?? 0) === 0 &&
        Number(guest?.whaSent ?? 0) === 0 &&
        (guest?.accept == null || guest?.accept === "") &&
        guest?.paid === false
      );
    });
    setUnpaidGuestsCount(unpaidGuests.length);
    setUnpaidGuestsNames(
      unpaidGuests.map((guest) => guest?.name).filter((name) => !!name),
    );
    setShowUnpaidGuestsList(false);
  }, [guests, canSeeUnpaidGuestsNotice]);

  useEffect(() => {
    if (
      !location.state?.openUnpaidNotice ||
      !canSeeUnpaidGuestsNotice ||
      unpaidGuestsCount <= 0
    ) {
      return;
    }
    setSystemPaymentLink("");
    setShowUnpaidGuestsList(false);
    setShowSystemNoticeModal(true);
    history.replace(ClientRoutes.User.main);
  }, [
    location.state?.openUnpaidNotice,
    canSeeUnpaidGuestsNotice,
    unpaidGuestsCount,
    history,
  ]);

  const selfInit = () => {
    handleGetAll();
    setShowList(false);
    setShowAddIphone(false);
    setShowAddAndroid(false);
    setShowAddManually(false);
    setShowAddExcel(false);
  };

  const getAllExcel = () => {
    let arr = [];
    let item;
    let dishes;
    let stats;
    let table;
    let transportation;
    const searchRegExp = /[a-zA-Zא-ת]/gi;
    let tables;
    if (Object.keys(guests).length > 0)
      for (const [key, value] of Object.entries(guests)) {
        if (user.isDigitalSeat) {
          if (value.table !== 0) {
            if (
              user.tablesArray[value.table - 1].title.split(" ")[0] === "או"
            ) {
              tables = user.tablesArray[value.table - 1].title
                .substring(3)
                .replaceAll(searchRegExp, "")
                .replaceAll(/[^,\d]/g, "");
              table = {
                // שולחן: `מספרי שולחנות הישיבה שלך הם: ${value.table}, ${tables}`,
                שולחן: `${value.table}, ${tables}`,
              };
            } else
              table = {
                // שולחן: `מספר השולחן שלך הוא: ${value.table}`,
                שולחן: value.table,
              };
          } else table = {};
        } else table = {};

        if (user.separation)
          item = {
            נשים: value.acceptWomen,
            גברים: value.acceptMen,
          };
        else item = {};

        if (user.transportation)
          transportation = {
            הסעה: value.transportation || "",
          };
        else transportation = {};

        if (user.specialDishes)
          dishes = {
            "ללא גלוטן": value.dishes[0] || "",
            צמחוני: value.dishes[1] || "",
            טבעוני: value.dishes[2] || "",
            גלאט: value.dishes[3] || "",
          };
        else dishes = {};

        if (isTal)
          stats = {
            תשובה: value.ans,
            סמס: value.smsSent,
            ווצאפ: value.whaSent,
          };
        else stats = {};
        arr.push({
          "שם מלא": value.name,
          "מס׳ נייד": value.phone,
          // קישור:
          //   `https://callup.ltd/n?n=` +
          //   `${window.btoa(user._id + " " + value._id)}`,
          קירבה: value.closeness,
          מוזמנים: value.sum,
          אישרו: value.accept === null ? "" : value.accept,
          הגיעו: value.arrived === null ? "" : value.arrived,
          מתנה: value.gift,
          ...item,
          ...stats,
          ...table,
          ...dishes,
          ...transportation,
          מזמין: value.inviting,
          קשר: value.owc,
          הערות: value.notes,
        });
      }
    exportToCSV(arr, "כללי");
  };

  const getCallsExcel = (callNumber) => {
    let item;
    let arr = [];
    let sortedArr = [];
    let posC = 0;
    let negC = 0;
    if (Object.keys(guests).length > 0)
      for (const [key, value] of Object.entries(guests))
        if (value.ans.includes(callNumber)) sortedArr.push(value);
    sortedArr.sort((a, b) => a["accept"] - b["accept"]);
    for (let i = 0; i < sortedArr.length; i++) {
      if (sortedArr[i].ans.includes("לא")) negC++;
      else posC++;
      if (user.separation)
        item = {
          נשים: sortedArr[i].acceptWomen,
          גברים: sortedArr[i].acceptMen,
        };
      else item = {};
      arr.push({
        "שם מלא": sortedArr[i].name,
        "מס׳ נייד": sortedArr[i].phone,
        קירבה: sortedArr[i].closeness,
        מוזמנים: sortedArr[i].sum,
        אישרו: sortedArr[i].accept === null ? "" : sortedArr[i].accept,
        ...item,
        מזמין: sortedArr[i].inviting,
        קשר: sortedArr[i].owc,
        מענה: sortedArr[i].ans,
        הערות: sortedArr[i].notes,
      });
    }
    arr.push({
      "שם מלא": "",
      "מס׳ נייד": "",
      קירבה: "",
      מוזמנים: "",
      אישרו: "",
      נשים: "",
      גברים: "",
      מזמין: "",
      קשר: "",
      מענה: "",
      הערות: "",
      ענו: posC,
      "לא ענו": negC,
    });
    if (arr.length > 1) exportToCSV(arr, `שיחה ${callNumber}`);
    else toast.warning(`עוד לא התקיימה שיחה ${callNumber}`);
  };

  const getTransExcel = () => {
    let arr = [];
    if (Object.keys(guests).length > 0)
      for (const [key, value] of Object.entries(guests))
        if (value.transportation > 0)
          arr.push({
            "שם מלא": value.name,
            "מס׳ נייד": value.phone,
            קירבה: value.closeness,
            מוזמנים: value.sum,
            אישרו: value.accept,
            הסעה: value.transportation,
            הערות: value.notes,
          });
    exportToCSV(arr, "הסעה");
  };

  const getNotesExcel = () => {
    let arr = [];
    let sortedArr = [];
    if (Object.keys(guests).length > 0)
      for (const [key, value] of Object.entries(guests))
        if (value.notes !== "") sortedArr.push(value);
    sortedArr.sort((a, b) => b["notes"].localeCompare(a["notes"]));
    for (let i = 0; i < sortedArr.length; i++)
      arr.push({
        "שם מלא": sortedArr[i].name,
        "מס׳ נייד": sortedArr[i].phone,
        קירבה: sortedArr[i].closeness,
        מוזמנים: sortedArr[i].sum,
        אישרו: sortedArr[i].accept,
        מזמין: sortedArr[i].inviting,
        קשר: sortedArr[i].owc,
        הערות: sortedArr[i].notes,
      });
    exportToCSV(arr, "הערות");
  };

  const getArrivedExcel = () => {
    let arr = [];
    let sortedArr = [];
    if (Object.keys(guests).length > 0)
      for (const [key, value] of Object.entries(guests))
        arr.push({
          "שם מלא": value.name,
          "מס׳ נייד": value.phone,
          קירבה: value.closeness,
          מוזמנים: value.sum,
          אישרו: value.accept === null ? "" : value.accept,
          הגיעו: value.arrived === null ? "" : value.arrived,
        });
    exportToCSV(arr, "נוכחות");
  };

  const getDishesExcel = () => {
    let arr = [];
    if (Object.keys(guests).length > 0)
      for (const [key, value] of Object.entries(guests))
        if (
          value.dishes[0] > 0 ||
          value.dishes[1] > 0 ||
          value.dishes[2] > 0 ||
          value.dishes[3] > 0
        )
          arr.push({
            "שם מלא": value.name,
            "מס׳ נייד": value.phone,
            קירבה: value.closeness,
            מוזמנים: value.sum,
            אישרו: value.accept,
            "ללא גלוטן": value.dishes[0],
            צמחוני: value.dishes[1],
            טבעוני: value.dishes[2],
            גלאט: value.dishes[3],
          });
    exportToCSV(arr, "מנות מיוחדות");
  };

  const getWeddingInvitationsTemplateExcel = () => {
    void exportWeddingInvitationsTemplateHeIL(guests);
  };

  const handleWeddingCompareFile = (e) => {
    const file = e.target.files?.[0];
    const input = e.target;
    if (!file) return;
    (async () => {
      try {
        const buf = await file.arrayBuffer();
        const { lines, newSinceExport } = compareWeddingExportFromArrayBuffer(
          buf,
          guests,
        );
        setWeddingCompareLines(lines);
        setWeddingCompareNewGuests(newSinceExport);
        if (lines.length === 0 && newSinceExport.length === 0) {
          toast.info(
            "אין שינויים ביחס לקובץ, ואין אורחים חדשים שלא הופיעו בקובץ.",
          );
        } else if (lines.length === 0 && newSinceExport.length > 0) {
          toast.info(
            "אין שינוי בעמודת האישור לשמות מהקובץ. יש אורחים שאישרו ולא היו בקובץ — ניתן להוריד למטה.",
          );
        }
      } catch (err) {
        console.error(err);
        toast.error("לא ניתן לקרוא את הקובץ");
      } finally {
        input.value = "";
      }
    })();
  };

  const downloadWeddingNewSinceExport = () => {
    void exportWeddingInvitationsTemplateForGuestList(
      weddingCompareNewGuests,
      "אורחים_נוספים_שאישרו_מאז.xlsx",
    );
  };

  // const add_del = (id, amount) => {
  //   setMultyChoise((prev) => {
  //     const newChoise = { ...prev };
  //     const wasSelected = newChoise[id] !== undefined;

  //     if (wasSelected) {
  //       delete newChoise[id];
  //     } else {
  //       newChoise[id] = true;
  //     }

  //     setMultyChoiseCounter((prevCounter) => {
  //       const newCounter = wasSelected
  //         ? prevCounter - amount
  //         : prevCounter + amount;
  //       setSelected(newCounter);
  //       return newCounter;
  //     });

  //     setClosenessChosenFlag((prev) => !prev);

  //     return newChoise;
  //   });
  // };

  const add_del = (id, amount) => {
    if (multyChoise[id] !== undefined) {
      delete multyChoise[id];
      multyChoiseCounter -= amount;
    } else {
      multyChoise[id] = true;
      multyChoiseCounter += amount;
    }
    setSelected(multyChoiseCounter);
    setClosenessChosenFlag(!closenessChosenFlag);
  };

  const handleSelectAll = () => {
    const guestsList = Array.isArray(guests)
      ? guests
      : Object.values(guests || {});
    guestsList.forEach((g) => {
      if (multyChoise[g._id] === undefined)
        add_del(g._id, g.accept ?? g.sum ?? 1);
    });
  };

  const getSender = () => {
    const p = user.producer;
    if (p === "משחק הכיסאות") return "ChairsGame";
    if (p === "מארגנת החתונות") return "WedPlanner";
    if (p === "שמחת עולם") return "SimhatOlam";
    if (p === "דובי הפקות") return "DubiProd";
    if (p === "אל על") return "EL_Al";
    if (p === "קליקסיט") return "ClickSeat";
    if (p === "PM ניהול והפקות אירועים") return "PM_Events";
    return p;
  };

  const handleSendMessageToSelected = async () => {
    if (isGuestBulkSmsBlocked) {
      toast.warning("עברת את המגבלה של 2 הודעות כלליות");
      return;
    }
    const guestsList = Array.isArray(guests)
      ? guests
      : Object.values(guests || {});
    const selectedGuests = guestsList.filter(
      (g) => multyChoise[g._id] && g.phone != null && g.phone !== "",
    );
    const noPhoneCount =
      Object.keys(multyChoise).length - selectedGuests.length;
    if (selectedGuests.length === 0) {
      toast.warning(
        noPhoneCount > 0
          ? "לאורחים שנבחרו אין מספר טלפון במערכת"
          : "בחרו אורחים לפני שליחת הודעה",
      );
      return;
    }
    if (!sendMessageContent.trim()) {
      toast.warning("יש להזין תוכן הודעה");
      return;
    }
    const body = {
      Data: {
        Message: "[#msg#]",
        Recipients: selectedGuests.map((g) => ({
          msg: sendMessageContent.trim(),
          Phone: g.phone,
        })),
        Settings: { Sender: getSender() },
      },
    };
    dispatch(sendGenericSms(body)).then((res) => {
      if (!res.payload?.error) {
        toast.success("ההודעה נשלחה בהצלחה");
        dispatch(incrementFreeSmsUsage()).then((inc) => {
          if (inc?.payload?.error) {
            toast.warning(
              "ההודעה נשלחה, אך עדכון מונה השליחות נכשל — מומלץ לרענן את העמוד.",
            );
          }
        });
        setShowSendMessageModal(false);
        setSendMessageContent("");
      } else toast.error(res.payload?.error);
    });
  };

  const getDefaultSendMessageContent = () => {
    if (user.eventType) {
      const bride = [user.brideFN, user.brideLN].filter(Boolean).join(" ");
      const groom = [user.groomFN, user.groomLN].filter(Boolean).join(" ");
      return groom
        ? `הודעה עבור החתונה של ${bride} ו${groom}:`
        : `הודעה עבור ${bride}`;
    }
    return `הודעה עבור ${user.calendarName || ""}:`;
  };

  const getOne = (id) => {
    dispatch(getById(id)).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else setShowEditGuest(res.payload);
    });
  };

  const handleEditGift = async (id, gift) => {
    dispatch(editGift(id, { gift: tempGift == 0 ? gift : tempGift })).then(
      async (res) => {
        if (res.payload?.error) toast.error(res.payload?.error);
        else toast.success("הפעולה בוצעה בהצלחה!");
        setTempGift(0);
      },
    );
  };

  let guestsArray = useMemo(() => {
    setBellAnimate(false);
    let counter = [0, 0, 0, 0]; // 0 - all, 1 - accept, 2 - wont come, 3 - not answer
    let duplicatePhones = {};
    const updateCounter = (accept, sum) => {
      counter[0] += parseInt(sum);
      if (accept > 0) {
        counter[1] += parseInt(accept);
        if (accept < sum) counter[2] += parseInt(sum) - parseInt(accept);
      } else if (accept === 0) counter[2] += parseInt(sum);
      else counter[3] += parseInt(sum);
    };
    const getBackground = (accept) => {
      if (accept > 0) return "#7b96c4";
      else if (accept === 0) return "#ec7070";
      else return "inherit";
    };
    let arr = [];
    let sortedArray = [];
    let mis = [];
    // let phones = {};
    if (Object.keys(guests).length > 0) {
      for (const [key, value] of Object.entries(guests)) {
        if (value.notes.includes("טעות במספר")) {
          mis.push(value.name);
        }
        updateCounter(value.accept, value.sum);
        if (
          value.phone !== "" &&
          value.phone !== null &&
          duplicatePhones[value.phone] === undefined
        )
          duplicatePhones[value.phone] = 1;
        else if (
          value.phone !== "" &&
          value.phone !== null &&
          duplicatePhones[value.phone] !== undefined
        )
          duplicatePhones[value.phone] += 1;
        if (what2show === "אישרו" && !value.accept > 0) continue;
        else if (
          what2show === "לא מגיעים" &&
          ((value.accept > 0 && value.accept >= value.sum) ||
            value.accept === null)
        )
          continue;
        else if (what2show === "ללא תשובה" && value.accept !== null) continue;
        else if (showNoPhone && value.phone?.length) continue;
        if (
          searchText
            .toLowerCase()
            .split(" ")
            .filter((i) => value.name?.toLowerCase().includes(i.toLowerCase()))
            .length === searchText.toLowerCase().split(" ").length ||
          value.phone?.includes(searchText) ||
          searchText === ""
        )
          sortedArray.push(value);
      }
      let dups = [];
      if (Object.keys(duplicatePhones).length > 0)
        for (const [key, value] of Object.entries(duplicatePhones))
          if (value > 1) dups.push(key);
      setShowDups(dups);
      if (sortedArray.length) {
        sortedArray.sort(
          (a, b) =>
            a["closeness"].localeCompare(b["closeness"]) ||
            a["name"].localeCompare(b["name"]),
        );
        let tempCloseness = "";
        let categories = [];
        let cats = [];
        let acceptClosenessCounter = 0;
        let sumClosenessCounter = 0;
        let categoryCounts = {}; // Store counts for each category
        for (let i = 0; i < sortedArray.length; i++) {
          if (phones[sortedArray[i].phone] === undefined)
            phones[sortedArray[i].phone] = true;
          if (sortedArray[i].closeness !== tempCloseness) {
            if (i !== 0 && searchText === "") {
              // Store count for previous category before resetting
              categoryCounts[sortedArray[i - 1].closeness] = {
                accept: acceptClosenessCounter,
                sum: sumClosenessCounter,
              };
            }
            // Reset counters for new category
            acceptClosenessCounter =
              sortedArray[i].accept !== null ? sortedArray[i].accept : 0;
            sumClosenessCounter = sortedArray[i].sum;
            categories.push({
              id: sortedArray[i].closeness,
              name: sortedArray[i].closeness,
            });
            arr.push(
              <FlexRowStart
                id={sortedArray[i].closeness}
                onClick={() => {
                  if (multiSelect) {
                    let temp = sortedArray.filter(
                      (x) => x.closeness === sortedArray[i].closeness,
                    );
                    for (let j = 0; j < temp.length; j++)
                      add_del(
                        temp[j]._id,
                        temp[j].accept || temp[j].sum,
                        // temp[j].accept >= 0 && temp[j].accept !== null
                        //   ? temp[j].accept
                        //   : temp[j].sum
                      );
                  }
                }}
                key={i + "c"}
                style={{
                  marginTop: "20px",
                  marginBottom: "8px",
                  cursor: multiSelect ? "pointer" : "auto",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "6px 14px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "6px",
                    boxShadow: "-2px 2px 5px rgba(123, 150, 196, 0.5)",
                    transition: "all 0.2s ease",
                    width: "fit-content",
                  }}
                  onMouseEnter={(e) => {
                    if (multiSelect) {
                      e.currentTarget.style.backgroundColor = "#f0f2f5";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (multiSelect) {
                      e.currentTarget.style.backgroundColor = "#f8f9fa";
                    }
                  }}
                >
                  <div
                    style={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      backgroundColor: "#7b96c4",
                      marginLeft: "8px",
                      flexShrink: 0,
                    }}
                  />
                  <MediumFont
                    csize={"16px"}
                    psize={"15px"}
                    style={{
                      color: "#555",
                      fontWeight: "500",
                      margin: 0,
                    }}
                  >
                    {sortedArray[i].closeness}
                  </MediumFont>
                </div>
              </FlexRowStart>,
            );
            tempCloseness = sortedArray[i].closeness;
          } else {
            // Accumulate for same category
            acceptClosenessCounter +=
              sortedArray[i].accept !== null ? sortedArray[i].accept : 0;
            sumClosenessCounter += sortedArray[i].sum;
          }
          const acceptValue =
            parseInt(sortedArray[i].accept) >= 0
              ? parseInt(sortedArray[i].accept)
              : null;
          const isAccepted = acceptValue !== null && acceptValue > 0;
          const isRejected = acceptValue === 0;
          // Colors matching the image - more subtle
          const statusColor = isRejected
            ? "#e74c3c"
            : isAccepted
              ? "#27ae60"
              : "#7f8c8d";
          const statusBgColor = isRejected
            ? "#fee"
            : isAccepted
              ? "#e8f8f0"
              : "#f8f9fa";
          const statusTextColor = isRejected
            ? "#c0392b"
            : isAccepted
              ? "#229954"
              : "#414d58";
          const isUnpaidGuest =
            user?.role === 5 &&
            sortedArray[i].paid === false &&
            sortedArray[i].phone != null &&
            String(sortedArray[i].phone).trim() !== "";

          arr.push(
            <GuestCard
              background={
                multyChoise[sortedArray[i]._id] !== undefined
                  ? "#e8eef5"
                  : "#ffffff"
              }
              style={{
                border: "0.5px solid rgba(200, 200, 200, 0.5)",
                borderRadius: "8px",
                // width: "48%",
                // marginRight: "2%",
                padding: "6px 6px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                cursor: "pointer",
                position: "relative",
                overflow: "hidden",
                // minHeight: "45px",
              }}
              key={i}
              onClick={() => {
                if (!multiSelect) getOne(sortedArray[i]._id);
                else
                  add_del(
                    sortedArray[i]._id,
                    sortedArray[i].accept || sortedArray[i].sum,
                    // sortedArray[i].accept >= 0 && sortedArray[i].accept !== null
                    //   ? sortedArray[i].accept
                    //   : sortedArray[i].sum
                  );
              }}
            >
              {/* Right side - Name */}
              <div
                style={{
                  flex: 1,
                  textAlign: "right",
                  marginLeft: "12px",
                  minWidth: 0,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "450",
                    color: "#2c3e50",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    fontFamily:
                      "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
                  }}
                >
                  {sortedArray[i].name}
                </div>
              </div>

              {/* Middle - Only essential icons */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                  marginLeft: "3px",
                  marginRight: "3px",
                  flexShrink: 0,
                }}
              >
                {(sortedArray[i].phone === "" ||
                  sortedArray[i].phone === null) && (
                  <img
                    src={noPhone}
                    alt="noPhone"
                    style={{
                      width: "14px",
                      height: "14px",
                      filter: "brightness(0) saturate(100%)",
                      opacity: 0.8,
                    }}
                  />
                )}
                {sortedArray[i].notes.includes("כרגע,") && isTal && (
                  <img
                    src={callRed}
                    alt="callRed"
                    style={{ marginLeft: "-5px", width: "18px" }}
                  />
                )}
                {sortedArray[i].notes && sortedArray[i].notes !== "" && (
                  <img
                    src={notes}
                    alt="notes"
                    style={{
                      width: "22px",
                      height: "22px",
                      marginLeft: "-3px",
                    }}
                  />
                )}
                {sortedArray[i].ans !== "" &&
                  sortedArray[i].ans[0] == "C" &&
                  isTal && (
                    <div
                      style={{
                        padding: "1px 3px",
                        borderRadius: "3px",
                        background: addAlpha("#7b96c4", 0.15),
                        fontSize: "14px",
                        color: "#5377bb",
                        fontWeight: "600",
                      }}
                    >
                      {sortedArray[i].ans.split("-")[0]}
                    </div>
                  )}
              </div>

              {/* Left side - Status badge */}
              {!giftMode && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: "0px",
                    flexShrink: 0,
                  }}
                >
                  <div
                    style={{
                      background: statusBgColor,
                      color: statusTextColor,
                      border: `0.5px solid ${statusTextColor}40`,
                      padding: "3px 5px",
                      borderRadius: "6px",
                      fontSize: "13px",
                      fontWeight: "500",
                      fontFamily: "system-ui, -apple-system, sans-serif",
                      // minWidth: "35px",
                      textAlign: "center",
                      lineHeight: "1.2",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                    }}
                  >
                    {(acceptValue !== null ? acceptValue + "/" : "") +
                      sortedArray[i].sum}
                  </div>
                </div>
              )}

              {/* Gift mode */}
              {giftMode && (
                <FlexRowBetween
                  style={{
                    width: "max-content",
                    marginLeft: "0px",
                  }}
                >
                  <input
                    onClick={(e) => e.stopPropagation()}
                    type="number"
                    min="0"
                    max="100000"
                    onChange={(e) => setTempGift(e.target.value)}
                    defaultValue={sortedArray[i].gift}
                    className="animate__animated animate__fadeIn"
                    style={{ padding: "2px 3px", marginLeft: "10px" }}
                  />
                  <img
                    className="animate__animated animate__fadeIn"
                    src={checkSign}
                    alt="checkSign"
                    style={{
                      cursor: "pointer",
                      width: "22px",
                      marginRight: "7px",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEditGift(sortedArray[i]._id, sortedArray[i].gift);
                    }}
                  />
                </FlexRowBetween>
              )}
              {isUnpaidGuest && (
                <>
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      backgroundColor: "rgba(255, 255, 255, 0.4)",
                      borderRadius: "8px",
                      pointerEvents: "none",
                      zIndex: 1,
                    }}
                  />
                  <svg
                    viewBox="0 0 100 100"
                    preserveAspectRatio="none"
                    style={{
                      position: "absolute",
                      inset: 0,
                      width: "100%",
                      height: "100%",
                      pointerEvents: "none",
                      zIndex: 2,
                    }}
                  >
                    <line
                      x1="0"
                      y1="0"
                      x2="100"
                      y2="100"
                      stroke="rgba(231, 76, 60, 0.6)"
                      strokeWidth="1.5"
                      vectorEffect="non-scaling-stroke"
                    />
                    <line
                      x1="100"
                      y1="0"
                      x2="0"
                      y2="100"
                      stroke="rgba(231, 76, 60, 0.6)"
                      strokeWidth="1.5"
                      vectorEffect="non-scaling-stroke"
                    />
                  </svg>
                </>
              )}
            </GuestCard>,
          );
        }
        if (searchText === "") {
          // Store count for last category
          if (sortedArray.length > 0) {
            const lastCloseness = sortedArray[sortedArray.length - 1].closeness;
            categoryCounts[lastCloseness] = {
              accept: acceptClosenessCounter,
              sum: sumClosenessCounter,
            };
          }
          // Add counts to categories
          const categoriesWithCounts = categories.map((cat) => ({
            ...cat,
            count: categoryCounts[cat.id]
              ? `${categoryCounts[cat.id].accept}/${categoryCounts[cat.id].sum}`
              : "0/0",
          }));
          setCategories(categoriesWithCounts);
        } else {
          setCategories([]);
        }
        setCats(cats);
      }
    }
    // עדכון bellAnimate בהתאם לשגיאות
    if (mis.length > 0) {
      setBellAnimate(true);
    } else {
      setBellAnimate(false);
    }
    return [arr, counter, mis];
  }, [
    guests,
    searchText,
    what2show,
    closenessChosenFlag,
    multiSelect,
    multyChoise,
    showNoPhone,
    tempGift,
    giftMode,
    isEventActive,
  ]);

  let sP = user.producer.toLowerCase() == "callup" ? "535000143" : "534311796";

  return (
    <div
      style={{
        width: "100%",
        height: `${window.screen.availHeight}px`,
        // background: "#f6fafe",
      }}
    >
      {!showtables && !showDayalim && (
        <BurgerMenu
          isOpen={isMainMenuBurgerOpen}
          onToggle={() => setIsMainMenuBurgerOpen(!isMainMenuBurgerOpen)}
          position="fixed"
          top="0px"
          left="0px"
          showErrorDot={guestsArray[2] && guestsArray[2].length > 0}
        >
          <MenuItem
            icon={
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path
                  d="M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            }
            text="לו״ז"
            onClick={() => {
              history.push(ClientRoutes.User.todos);
              setIsMainMenuBurgerOpen(false);
            }}
            color="#333"
          />

          <MenuItem
            icon={
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 5v14M5 12h14"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            }
            text="הוספת אורחים"
            onClick={() => {
              setShowAddOptions(true);
              setIsMainMenuBurgerOpen(false);
            }}
            color="#333"
          />

          <MenuItem
            icon={
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path
                  d="M9 11H15M9 15H15M9 7H15M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            }
            text="דוחות"
            onClick={() => {
              setShowMenu(false);
              setShowReports(true);
              setIsMainMenuBurgerOpen(false);
            }}
            color="#333"
          />

          <MenuItem
            icon={
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2L2 7L12 12L22 7L12 2Z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2 17L12 22L22 17"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2 12L12 17L22 12"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            }
            text="הדרכות"
            onClick={() => {
              history.push(ClientRoutes.User.instruction);
              setIsMainMenuBurgerOpen(false);
            }}
            color="#333"
          />
          <MenuItem
            icon={
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path
                  d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <polyline
                  points="14,2 14,8 20,8"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="16"
                  y1="13"
                  x2="8"
                  y2="13"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="16"
                  y1="17"
                  x2="8"
                  y2="17"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <polyline
                  points="22,6 12,13 2,6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            }
            text="הזמנה"
            onClick={() => {
              history.push(ClientRoutes.User.editDetails);
              setIsMainMenuBurgerOpen(false);
            }}
            color="#333"
          />

          <MenuItem
            icon={
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path
                  d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="2"
                  y1="22"
                  x2="22"
                  y2="2"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            }
            text={showNoPhone ? "חזרה למצב רגיל" : "ללא מספר"}
            onClick={() => {
              setShowNoPhone(!showNoPhone);
              setIsMainMenuBurgerOpen(false);
            }}
            color="#333"
          />

          <MenuItem
            icon={
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path
                  d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <rect
                  x="8"
                  y="2"
                  width="8"
                  height="4"
                  rx="1"
                  ry="1"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <path
                  d="M12 11h4M12 15h4M8 11h.01M8 15h.01"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            }
            text="כפולים"
            onClick={() => {
              handleShowDups();
              setIsMainMenuBurgerOpen(false);
            }}
            color="#333"
          />

          {user?.role === 6 ? (
            <MenuItem
              icon={
                <span
                  style={{ display: "flex", gap: "4px", alignItems: "center" }}
                >
                  <img
                    src={sms}
                    alt=""
                    style={{ width: "14px", height: "14px" }}
                  />
                  <img
                    src={whatsapp}
                    alt=""
                    style={{ width: "17px", height: "17px" }}
                  />
                </span>
              }
              text="יתרות"
              onClick={() => {
                setShowBalancesModal(true);
                setIsMainMenuBurgerOpen(false);
              }}
              color="#333"
            />
          ) : (
            <MenuItem
              icon={
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              }
              text="תמיכה טכנית"
              onClick={() => {
                setShowSupportModal(!showSupportModal);
                setIsMainMenuBurgerOpen(false);
              }}
              color="#333"
            />
          )}

          <MenuItem
            icon={
              <img
                src={bellAnimate ? bellOrange : bell}
                alt="bell"
                style={{ width: "16px", height: "16px" }}
              />
            }
            text="שגיאות"
            onClick={() => {
              setShowMisModal(!showMisModal);
              setIsMainMenuBurgerOpen(false);
            }}
            color="#333"
            showDot={guestsArray[2] && guestsArray[2].length > 0}
            animate={guestsArray[2] && guestsArray[2].length > 0}
          />

          {/* <MenuItem
              icon={
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              }
              text="מתנות באשראי"
              onClick={() => {
                setShowGifts(true);
                setIsMainMenuBurgerOpen(false);
              }}
              color="#333"
            /> */}

          {/* <MenuItem
              icon={
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                  <path
                  d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                </svg>
              }
              text={!giftMode ? "מעבר למילוי מתנות" : "חזרה למצב אישורים"}
              onClick={() => {
                setGiftMode(!giftMode);
                setIsMainMenuBurgerOpen(false);
              }}
              color="#333"
            /> */}

          {user.isDigitalSeat && (
            <MenuItem
              icon={
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <rect
                    x="3"
                    y="3"
                    width="18"
                    height="18"
                    rx="2"
                    ry="2"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <line
                    x1="9"
                    y1="3"
                    x2="9"
                    y2="21"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <line
                    x1="15"
                    y1="3"
                    x2="15"
                    y2="21"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <line
                    x1="3"
                    y1="9"
                    x2="21"
                    y2="9"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <line
                    x1="3"
                    y1="15"
                    x2="21"
                    y2="15"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              }
              text="סידורי הושבה"
              onClick={() => {
                setShowtables(!showtables);
                setIsMainMenuBurgerOpen(false);
              }}
              color="#333"
            />
          )}
          {isTal && user.isDigitalSeat && (
            <MenuItem
              icon={
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M3 7V5a2 2 0 0 1 2-2h6l2 2h6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 13l2 2 4-4"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              }
              text="מי כאן?"
              onClick={() => {
                setShowDayalim(!showDayalim);
                setIsMainMenuBurgerOpen(false);
              }}
              color="#333"
            />
          )}
          <MenuItem
            icon={
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <circle
                  cx="12"
                  cy="12"
                  r="3"
                  stroke="currentColor"
                  strokeWidth="2"
                />
              </svg>
            }
            text={accessibilityEnabled ? "נגישות (מופעלת)" : "נגישות"}
            onClick={() => {
              openAccessibilityPanel();
              setIsMainMenuBurgerOpen(false);
            }}
            color="#333"
          />
          {canShowInstallPwa && (
            <MenuItem
              icon={
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <polyline
                    points="7,10 12,15 17,10"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <line
                    x1="12"
                    y1="15"
                    x2="12"
                    y2="3"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              }
              text="התקן אפליקציה"
              onClick={handleInstallPwa}
              color="#333"
            />
          )}
          <MenuItem
            icon={
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6v6l4 2"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            }
            text={user?.isReady ? "אירוע פעיל" : "אירוע לא פעיל"}
            onClick={() => {
              if (user?.isReady) {
                setShowIsReadyConfirm(true);
              } else {
                setShowHadrahot(true);
              }
              setIsMainMenuBurgerOpen(false);
            }}
            color={user?.isReady ? "#2e7d32" : "#c62828"}
            actionText={user?.isReady ? "הפסק" : "הפעל"}
            actionColor={user?.isReady ? "#c62828" : "#2e7d32"}
          />
          <MenuItem
            icon={
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path
                  d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M7 16l4-4 4 4M12 12v9"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            }
            text="התנתקות"
            onClick={() => {
              setShowLogout(true);
              setIsMainMenuBurgerOpen(false);
            }}
            color="#333"
          />
        </BurgerMenu>
      )}
      <div
        style={{
          width: "100%",
          position: "fixed",
          left: "0",
          top: "0",
          zIndex: 2,
          background: "white",
          // background: "linear-gradient(to bottom, #e2ebff,#fbfdff, #ffffff)",
          paddingBottom: "10px",
          paddingTop: "5px",
          boxShadow: "0 2px 4px #bcb8b892",
        }}
      >
        <FlexRowBetween
          id="hhhj"
          style={{
            width: "min-content",
            margin: "0 auto",
            padding: "0px 0px",
            marginRight: "0px",
            marginBottom: "10px",
          }}
        >
          <div
            onClick={() => setWhat2show("הוזמנו")}
            style={{
              padding: "5px 10px",
              cursor: "pointer",
              transition: "500ms",
              borderBottom:
                what2show === "הוזמנו"
                  ? "5px solid #d3e0f6b6"
                  : "5px solid white",
              textAlign: "center",
            }}
          >
            <div
              style={{
                width: "45px",
                height: "45px",
                borderRadius: "50%",
                backgroundColor: "#d3e0f67c",
                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.4)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 8px",
              }}
            >
              <img
                src={users}
                alt="users"
                style={{ width: "28px", height: "28px" }}
              />
            </div>
            <RespFont csize={"14px"} psize={"12px"}>
              הוזמנו
            </RespFont>
            <RespFont>{guestsArray[1][0]}</RespFont>
          </div>
          <div
            onClick={() => setWhat2show("אישרו")}
            style={{
              padding: "5px 5px",
              cursor: "pointer",
              transition: "500ms",
              borderBottom:
                what2show === "אישרו"
                  ? "5px solid #d5f4e6b1"
                  : "5px solid white",
              textAlign: "center",
            }}
          >
            <div
              style={{
                width: "45px",
                height: "45px",
                borderRadius: "50%",
                backgroundColor: "#d5f4e671",
                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.4)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 8px",
              }}
            >
              <img
                src={emojiSmile1}
                alt="emojiSmile1"
                style={{ width: "28px", height: "28px" }}
              />
            </div>
            <RespFont csize={"14px"} psize={"12px"}>
              אישרו
            </RespFont>
            <RespFont>{guestsArray[1][1]}</RespFont>
          </div>
          <div
            onClick={() => setWhat2show("לא מגיעים")}
            style={{
              padding: "5px 8px",
              cursor: "pointer",
              transition: "500ms",
              borderBottom:
                what2show === "לא מגיעים"
                  ? "5px solid #fde0e0c5"
                  : "5px solid white",
              textAlign: "center",
            }}
          >
            <div
              style={{
                width: "45px",
                height: "45px",
                borderRadius: "50%",
                backgroundColor: "#fde0e08b",
                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.4)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 8px",
              }}
            >
              <img
                src={emojiSad1}
                alt="emojiSad1"
                style={{ width: "28px", height: "28px" }}
              />
            </div>
            <RespFont
              csize={"14px"}
              psize={"12px"}
              style={{ width: "max-content" }}
            >
              לא מגיעים
            </RespFont>
            <RespFont>{guestsArray[1][2]}</RespFont>
          </div>
          <div
            onClick={() => setWhat2show("ללא תשובה")}
            style={{
              padding: "5px 0px",
              cursor: "pointer",
              transition: "500ms",
              borderBottom:
                what2show === "ללא תשובה"
                  ? "5px solid #d4d2d2"
                  : "5px solid white",
              textAlign: "center",
            }}
          >
            <div
              style={{
                width: "45px",
                height: "45px",
                borderRadius: "50%",
                backgroundColor: "#f0f0f0",
                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.4)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 8px",
              }}
            >
              <img
                src={emojiNoMouth1}
                alt="emojiNoMouth1"
                style={{ width: "28px", height: "28px" }}
              />
            </div>
            <RespFont
              csize={"14px"}
              psize={"12px"}
              style={{ width: "max-content" }}
            >
              ללא תשובה
            </RespFont>
            <RespFont>{guestsArray[1][3]}</RespFont>
          </div>
        </FlexRowBetween>
        <FlexRowBetween style={{ width: "94%", margin: "0px auto" }}>
          {/* Categories Dropdown - Left side */}
          {categories.length > 0 && (
            <div
              style={{
                position: "relative",
                marginRight: "0px",
                width: "90px",
                zIndex: 1002,
              }}
            >
              <button
                ref={categoriesButtonRef}
                onClick={() =>
                  setIsCategoriesDropdownOpen(!isCategoriesDropdownOpen)
                }
                style={{
                  padding: "5px 12px",
                  borderRadius: "8px",
                  border: `2px solid ${addAlpha("#7b96c4", 0.4)}`,
                  backgroundColor: "#fff",
                  fontSize: "13px",
                  fontWeight: "500",
                  cursor: "pointer",
                  outline: "none",
                  fontFamily: "inherit",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  boxShadow: isCategoriesDropdownOpen
                    ? "0 4px 12px rgba(123, 150, 196, 0.2)"
                    : "0 2px 6px rgba(123, 150, 196, 0.1)",
                  transition: "all 0.3s ease",
                  color: "#333",
                  width: "100%",
                  direction: "rtl",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = addAlpha("#7b96c4", 0.6);
                  e.currentTarget.style.boxShadow =
                    "0 4px 12px rgba(123, 150, 196, 0.2)";
                }}
                onMouseLeave={(e) => {
                  if (!isCategoriesDropdownOpen) {
                    e.currentTarget.style.borderColor = addAlpha(
                      "#7b96c4",
                      0.4,
                    );
                    e.currentTarget.style.boxShadow =
                      "0 2px 6px rgba(123, 150, 196, 0.1)";
                  }
                }}
              >
                <span>
                  קטגוריות
                  {/* {showAllCategories
                    ? "קטגוריות"
                    : categories.find((c) => c.id === selectedCategory)?.name ||
                      "בחר קטגוריה"} */}
                </span>
                <span
                  style={{
                    transform: isCategoriesDropdownOpen
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                    fontSize: "12px",
                    marginRight: "9px",
                    marginTop: "1.5px",
                  }}
                >
                  ▼
                </span>
              </button>
              {isCategoriesDropdownOpen && (
                <div
                  ref={categoriesDropdownRef}
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    marginTop: "6px",
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    border: `2px solid ${addAlpha("#7b96c4", 0.3)}`,
                    boxShadow: "0 8px 24px rgba(123, 150, 196, 0.2)",
                    maxHeight: "50vh",
                    overflowY: "auto",
                    zIndex: 1003,
                    minWidth: "140px",
                  }}
                >
                  {/* <div
                    onClick={() => {
                      setShowAllCategories(true);
                      setSelectedCategory("");
                      setIsCategoriesDropdownOpen(false);
                    }}
                    style={{
                      padding: "8px 6px",
              cursor: "pointer",
                      borderBottom: `1px solid ${addAlpha("#7b96c4", 0.1)}`,
                      backgroundColor: showAllCategories
                        ? addAlpha("#7b96c4", 0.1)
                        : "transparent",
                      transition: "background-color 0.2s ease",
                      fontSize: "13px",
                      color: "#333",
                      textAlign: "right",
                      direction: "rtl",
                      fontWeight: "500",
                    }}
                    onMouseEnter={(e) => {
                      if (!showAllCategories) {
                        e.currentTarget.style.backgroundColor = addAlpha(
                          "#7b96c4",
                          0.05
                        );
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!showAllCategories) {
                        e.currentTarget.style.backgroundColor = "transparent";
                      }
                    }}
                  >
                    הצג הכל
                  </div> */}
                  {categories.map((cat) => (
                    <div
                      key={cat.id}
                      onClick={() => {
                        setSelectedCategory(cat.id);
                        setShowAllCategories(false);
                        handleClickScroll(cat.id);
                        setIsCategoriesDropdownOpen(false);
                      }}
                      style={{
                        padding: "8px 6px",
                        cursor: "pointer",
                        borderBottom:
                          cat.id !== categories[categories.length - 1].id
                            ? `1px solid ${addAlpha("#7b96c4", 0.1)}`
                            : "none",
                        backgroundColor:
                          selectedCategory === cat.id && !showAllCategories
                            ? addAlpha("#7b96c4", 0.1)
                            : "transparent",
                        transition: "background-color 0.2s ease",
                        fontSize: "13px",
                        color: "#333",
                        textAlign: "right",
                        direction: "rtl",
                      }}
                      onMouseEnter={(e) => {
                        if (selectedCategory !== cat.id || showAllCategories) {
                          e.currentTarget.style.backgroundColor = addAlpha(
                            "#7b96c4",
                            0.05,
                          );
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (selectedCategory !== cat.id || showAllCategories) {
                          e.currentTarget.style.backgroundColor = "transparent";
                        }
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          direction: "rtl",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "500",
                            textAlign: "right",
                            marginRight: "2px",
                          }}
                        >
                          {cat.name}
                        </span>
                        <span
                          style={{
                            color: "#4a5a7a",
                            fontSize: "12px",
                            marginLeft: "2px",
                            marginRight: "5px",
                            fontWeight: "600",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {cat.count}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Multi-select button - Middle */}
          <button
            onClick={() => {
              setMultiSelect(!multiSelect);
              multyChoise = {};
              multyChoiseCounter = 0;
              setSelected(0);
            }}
            style={{
              padding: "5px 10px",
              borderRadius: "8px",
              border: `2px solid ${addAlpha("#7b96c4", 0.4)}`,
              backgroundColor: multiSelect ? addAlpha("#7b96c4", 0.1) : "#fff",
              fontSize: "12px",
              fontWeight: "500",
              cursor: "pointer",
              outline: "none",
              fontFamily: "inherit",
              color: "#333",
              transition: "all 0.3s ease",
              boxShadow: "0 2px 6px rgba(123, 150, 196, 0.1)",
              direction: "rtl",
              whiteSpace: "nowrap",
            }}
            onMouseEnter={(e) => {
              if (!multiSelect) {
                e.currentTarget.style.borderColor = addAlpha("#7b96c4", 0.6);
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(123, 150, 196, 0.2)";
              }
            }}
            onMouseLeave={(e) => {
              if (!multiSelect) {
                e.currentTarget.style.borderColor = addAlpha("#7b96c4", 0.4);
                e.currentTarget.style.boxShadow =
                  "0 2px 6px rgba(123, 150, 196, 0.1)";
              }
            }}
          >
            {multiSelect ? "ביטול" : "בחירה מרובה"}
          </button>
          {/* Search - Right side */}
          <div
            style={{
              position: "relative",
              marginLeft: "0px",
              width: "110px",
            }}
          >
            {searchText && (
              <img
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setSearchText("");
                  setTimeout(() => {
                    if (inputRef.current) {
                      inputRef.current.focus();
                    }
                  }, 0);
                }}
                src={clear}
                alt="clear"
                style={{
                  cursor: "pointer",
                  position: "absolute",
                  left: "8px",
                  zIndex: 2,
                  width: "24px",
                  height: "24px",
                  padding: "5px",
                  borderRadius: "4px",
                  top: "15%",
                  backgroundColor: `${addAlpha("#7b96c4", 0.1)}`,
                }}
              />
            )}
            <input
              value={searchText}
              ref={inputRef}
              type="text"
              placeholder="חיפוש"
              name="value"
              style={{
                padding: "5px 8px",
                paddingRight: "5px",
                borderRadius: "8px",
                border: `2px solid ${addAlpha("#7b96c4", 0.4)}`,
                backgroundColor: "#fff",
                fontSize: "13px",
                fontWeight: "500",
                outline: "none",
                fontFamily: "inherit",
                width: "100%",
                boxShadow: "0 2px 6px rgba(123, 150, 196, 0.1)",
                transition: "all 0.3s ease",
                color: "#333",
              }}
              onChange={(e) => setSearchText(e.target.value)}
              onFocus={(e) => {
                e.currentTarget.style.borderColor = addAlpha("#7b96c4", 0.6);
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(123, 150, 196, 0.2)";
              }}
              onBlur={(e) => {
                e.currentTarget.style.borderColor = addAlpha("#7b96c4", 0.4);
                e.currentTarget.style.boxShadow =
                  "0 2px 6px rgba(123, 150, 196, 0.1)";
              }}
            />
          </div>
        </FlexRowBetween>
        {/* Multi-select actions row */}
        {multiSelect && (
          <div
            style={{
              width: "94%",
              margin: "10px auto 0",
              padding: "8px 10px",
              backgroundColor: "#f8f9fa",
              borderRadius: "8px",
              border: `1px solid ${addAlpha("#7b96c4", 0.2)}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "nowrap",
              gap: "6px",
              direction: "rtl",
            }}
          >
            <div
              style={{
                fontSize: "13px",
                fontFamily: "system-ui, -apple-system, sans-serif",
                fontWeight: "500",
                color: "#333",
                whiteSpace: "nowrap",
                flexShrink: 0,
              }}
            >
              נבחרו {selected}
            </div>
            <div
              style={{
                display: "flex",
                gap: "4px",
                flexWrap: "nowrap",
                direction: "rtl",
                flex: 1,
                justifyContent: "flex-start",
                minWidth: 0,
              }}
            >
              <button
                onClick={() => {
                  if (selected) {
                    setShowDelete(true);
                  } else {
                    alert("קודם בחרו אורחים ורק אז לחצו לפעולה הבאה");
                  }
                }}
                style={{
                  padding: "5px 8px",
                  borderRadius: "6px",
                  border: "1px solid #e0e0e0",
                  backgroundColor: "#fff",
                  fontSize: "11px",
                  fontWeight: "500",
                  cursor: selected ? "pointer" : "not-allowed",
                  outline: "none",
                  fontFamily: "inherit",
                  color: selected ? "#e74c3c" : "#999",
                  transition: "all 0.2s ease",
                  opacity: selected ? 1 : 0.6,
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}
                disabled={!selected}
                onMouseEnter={(e) => {
                  if (selected) {
                    e.currentTarget.style.backgroundColor = "#fee";
                    e.currentTarget.style.borderColor = "#e74c3c";
                  }
                }}
                onMouseLeave={(e) => {
                  if (selected) {
                    e.currentTarget.style.backgroundColor = "#fff";
                    e.currentTarget.style.borderColor = "#e0e0e0";
                  }
                }}
              >
                מחיקה
              </button>
              {(user.eventType || isTal) && (
                <button
                  onClick={() => {
                    if (selected) {
                      setShowOwcChange(true);
                    } else {
                      alert("קודם בחרו אורחים ורק אז לחצו לפעולה הבאה");
                    }
                  }}
                  style={{
                    padding: "5px 8px",
                    borderRadius: "6px",
                    border: "1px solid #e0e0e0",
                    backgroundColor: "#fff",
                    fontSize: "11px",
                    fontWeight: "500",
                    cursor: selected ? "pointer" : "not-allowed",
                    outline: "none",
                    fontFamily: "inherit",
                    color: selected ? "#333" : "#999",
                    transition: "all 0.2s ease",
                    opacity: selected ? 1 : 0.6,
                    whiteSpace: "nowrap",
                    flexShrink: 0,
                  }}
                  disabled={!selected}
                  onMouseEnter={(e) => {
                    if (selected) {
                      e.currentTarget.style.backgroundColor = "#f8f9fa";
                      e.currentTarget.style.borderColor = "#7b96c4";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (selected) {
                      e.currentTarget.style.backgroundColor = "#fff";
                      e.currentTarget.style.borderColor = "#e0e0e0";
                    }
                  }}
                >
                  עריכת מזמין + קשר
                </button>
              )}
              <button
                onClick={() => {
                  if (selected) {
                    setShowClosenessChange(true);
                  } else {
                    alert("קודם בחרו אורחים ורק אז לחצו לפעולה הבאה");
                  }
                }}
                style={{
                  padding: "5px 8px",
                  borderRadius: "6px",
                  border: "1px solid #e0e0e0",
                  backgroundColor: "#fff",
                  fontSize: "11px",
                  fontWeight: "500",
                  cursor: selected ? "pointer" : "not-allowed",
                  outline: "none",
                  fontFamily: "inherit",
                  color: selected ? "#333" : "#999",
                  transition: "all 0.2s ease",
                  opacity: selected ? 1 : 0.6,
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}
                disabled={!selected}
                onMouseEnter={(e) => {
                  if (selected) {
                    e.currentTarget.style.backgroundColor = "#f8f9fa";
                    e.currentTarget.style.borderColor = "#7b96c4";
                  }
                }}
                onMouseLeave={(e) => {
                  if (selected) {
                    e.currentTarget.style.backgroundColor = "#fff";
                    e.currentTarget.style.borderColor = "#e0e0e0";
                  }
                }}
              >
                עריכת קטגוריה
              </button>
            </div>
          </div>
        )}
        {console.log(unpaidGuestsCount)}
        {canSeeUnpaidGuestsNotice && unpaidGuestsCount > 0 && (
          <div
            onClick={() => {
              setSystemPaymentLink("");
              setShowUnpaidGuestsList(false);
              setShowSystemNoticeModal(true);
            }}
            style={{
              width: "94%",
              margin: "10px auto 0",
              padding: "8px 10px",
              borderRadius: "9px",
              border: "1px solid #ef9a9a",
              background: "#fff5f5",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              direction: "rtl",
              cursor: "pointer",
              userSelect: "none",
              animation: "systemNoticeBlink 1s infinite",
            }}
            title="הודעת מערכת"
          >
            <span
              style={{ color: "#c62828", fontWeight: 800, fontSize: "18px" }}
            >
              !
            </span>
            <span
              style={{ color: "#c62828", fontWeight: 700, fontSize: "14px" }}
            >
              הודעת מערכת
            </span>
          </div>
        )}
        {/* isTal: בחר הכל + שליחת הודעה */}
        {isTal && multiSelect && (
          <div
            style={{
              width: "94%",
              margin: "8px auto 0",
              padding: "8px 10px",
              backgroundColor: "#f0f4ff",
              borderRadius: "8px",
              border: `1px solid ${addAlpha("#7b96c4", 0.25)}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "8px",
              direction: "rtl",
              flexWrap: "wrap",
            }}
          >
            <button
              onClick={handleSelectAll}
              style={{
                padding: "5px 10px",
                borderRadius: "6px",
                border: "1px solid #e0e0e0",
                backgroundColor: "#fff",
                fontSize: "12px",
                fontWeight: "500",
                cursor: "pointer",
                outline: "none",
                fontFamily: "inherit",
                color: "#333",
                transition: "all 0.2s ease",
                whiteSpace: "nowrap",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#f8f9fa";
                e.currentTarget.style.borderColor = "#7b96c4";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#fff";
                e.currentTarget.style.borderColor = "#e0e0e0";
              }}
            >
              בחר הכל
            </button>
            <button
              onClick={() => {
                if (!selected) {
                  toast.warning("קודם בחרו אורחים ורק אז לחצו לשליחת הודעה");
                  return;
                }
                if (isGuestBulkSmsBlocked) {
                  toast.warning("עברת את המגבלה של 2 הודעות כלליות");
                  return;
                }
                setSendMessageContent(getDefaultSendMessageContent());
                setShowSendMessageModal(true);
              }}
              style={{
                padding: "5px 10px",
                borderRadius: "6px",
                border: "1px solid #e0e0e0",
                backgroundColor: "#fff",
                fontSize: "12px",
                fontWeight: "500",
                cursor:
                  selected && !isGuestBulkSmsBlocked
                    ? "pointer"
                    : "not-allowed",
                outline: "none",
                fontFamily: "inherit",
                color: selected && !isGuestBulkSmsBlocked ? "#333" : "#999",
                transition: "all 0.2s ease",
                opacity: selected && !isGuestBulkSmsBlocked ? 1 : 0.6,
                whiteSpace: "nowrap",
              }}
              disabled={!selected}
              onMouseEnter={(e) => {
                if (selected && !isGuestBulkSmsBlocked) {
                  e.currentTarget.style.backgroundColor = "#f8f9fa";
                  e.currentTarget.style.borderColor = "#7b96c4";
                }
              }}
              onMouseLeave={(e) => {
                if (selected && !isGuestBulkSmsBlocked) {
                  e.currentTarget.style.backgroundColor = "#fff";
                  e.currentTarget.style.borderColor = "#e0e0e0";
                }
              }}
            >
              שליחת הודעה כללית
            </button>
          </div>
        )}
      </div>
      <ListHolder
        style={{
          marginTop:
            widthS > 768
              ? multiSelect
                ? isTal
                  ? "300px"
                  : "260px"
                : "180px"
              : multiSelect
                ? isTal
                  ? "290px"
                  : "250px"
                : "170px",
          backgroundColor: "#e2ebff18",
          padding: "8px",
          borderRadius: "8px",
        }}
      >
        {[guestsArray[0]]}
      </ListHolder>
      <div style={{ height: "50px" }} />
      {/* <div
        onClick={() => handleClickScroll("hhhj")}
        style={{
          width: "min-content",
          boxShadow:
            "0 2px 2px rgba(0, 0, 0, 0.11), 0 -2px 2px rgba(0, 0, 0, 0.11)",
          borderRadius: "50px",
          padding: "5px",
          fontWeight: "700",
          cursor: "pointer",
          position: "fixed",
          bottom: "70px",
          left: "20px",
        }}
      >
        <div
          style={{
            padding: "2px 2px",

            backgroundColor: "#7b96c4",
            transition: "all 0.2s",
            borderRadius: "50px",
            width: "max-content",
          }}
        >
          <img src={arrowUp} alt="arrowUp" style={{ width: "25px" }} />
        </div>
      </div> */}
      {guestsLoading && <FilledLoading />}
      {showLoading && <OpacityLoading />}
      {showLoading && <FilledLoading />}
      {showAddOptions && (
        <GenericModal
          init={setShowAddOptions}
          div={
            <ToolsOptions
              data={[
                <TextWithPic
                  key={1}
                  onClick={() => {
                    setShowAddOptions(false);
                    setShowAddManually(true);
                  }}
                >
                  ידני
                </TextWithPic>,
                <TextWithPic
                  key={2}
                  onClick={() => {
                    setShowAddOptions(false);
                    setShowAddExcel(true);
                  }}
                >
                  אקסל
                </TextWithPic>,
                <TextWithPic
                  key={3}
                  onClick={() => {
                    setShowAddOptions(false);
                    setShowList(true);
                  }}
                >
                  רשימה
                </TextWithPic>,
                <TextWithPic
                  key={4}
                  onClick={() => {
                    setShowAddOptions(false);
                    setShowAddIphone(true);
                  }}
                >
                  אייפון
                </TextWithPic>,
                <TextWithPic
                  key={5}
                  onClick={() => {
                    setShowAddOptions(false);
                    setShowAddAndroid(true);
                  }}
                >
                  אנדרואיד
                </TextWithPic>,
              ]}
            />
          }
        />
      )}
      {showMenu && (
        <GenericModal
          init={setShowMenu}
          div={
            <ToolsOptions
              data={[
                <TextWithPic
                  key={1}
                  onClick={() => history.push(ClientRoutes.User.todos)}
                >
                  לו״ז
                </TextWithPic>,
                <TextWithPic
                  key={2}
                  onClick={() => {
                    setShowMenu(false);
                    setShowReports(true);
                  }}
                >
                  דוחות
                </TextWithPic>,
                // <TextWithPic
                //   onClick={() => history.push(ClientRoutes.User.tables)}
                //   key={5}
                // >
                //   שולחנות
                // </TextWithPic>,
                <TextWithPic
                  onClick={() => history.push(ClientRoutes.User.instruction)}
                  key={7}
                >
                  הדרכות
                </TextWithPic>,
                <TextWithPic
                  onClick={() => history.push(ClientRoutes.User.editDetails)}
                  key={3}
                >
                  הזמנה
                </TextWithPic>,
                <TextWithPic
                  onClick={() => setShowNoPhone(!showNoPhone)}
                  key={4}
                >
                  {showNoPhone ? "חזרה למצב רגיל" : "ללא מספר"}
                </TextWithPic>,
                <TextWithPic onClick={() => handleShowDups()} key={6}>
                  כפולים
                </TextWithPic>,
                user?.role === 6 ? (
                  <TextWithPic
                    key="balances"
                    onClick={() => setShowBalancesModal(true)}
                  >
                    יתרות
                  </TextWithPic>
                ) : (
                  <TextWithPic
                    key="support"
                    onClick={() => setShowSupportModal(!showSupportModal)}
                  >
                    תמיכה טכנית
                  </TextWithPic>
                ),
                <TextWithPic onClick={() => setShowGifts(true)} key={8}>
                  מתנות באשראי
                </TextWithPic>,
                <TextWithPic onClick={() => setGiftMode(!giftMode)} key={9}>
                  {!giftMode ? "מעבר למילוי מתנות" : "חזרה למצב אישורים"}
                </TextWithPic>,
              ]}
            />
          }
        />
      )}
      {showReports && (
        <GenericModal
          init={setShowReports}
          div={
            <ToolsOptions
              data={[
                <TextWithPic key={1} onClick={getAllExcel}>
                  כללי
                </TextWithPic>,
                <TextWithPic key={9} onClick={getArrivedExcel}>
                  נוכחות
                </TextWithPic>,
                <TextWithPic key={2} onClick={getTransExcel}>
                  הסעה
                </TextWithPic>,
                <TextWithPic key={3} onClick={getNotesExcel}>
                  הערות
                </TextWithPic>,
                <TextWithPic key={4} onClick={getDishesExcel}>
                  מנות מיוחדות
                </TextWithPic>,
                <TextWithPic
                  key="iplan"
                  onClick={() => {
                    setShowReports(false);
                    setShowIplanModal(true);
                  }}
                >
                  אייפלאן
                </TextWithPic>,
                <div
                  key="calls-row-1"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    key={5}
                    onClick={() => getCallsExcel(1)}
                    style={{
                      flex: "1",
                      backgroundColor: "#ffffff",
                      border: "1px solid #e8e8e8",
                      borderRadius: "10px",
                      padding: "18px 24px",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      textAlign: "right",
                      direction: "rtl",
                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#f8f9fa";
                      e.currentTarget.style.borderColor = "#d8d8d8";
                      e.currentTarget.style.boxShadow =
                        "0 2px 6px rgba(0, 0, 0, 0.12)";
                      e.currentTarget.style.transform = "translateY(-1px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#ffffff";
                      e.currentTarget.style.borderColor = "#e8e8e8";
                      e.currentTarget.style.boxShadow =
                        "0 1px 3px rgba(0, 0, 0, 0.08)";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    <span
                      style={{
                        fontSize: "15px",
                        fontWeight: "400",
                        color: "#2c3e50",
                        fontFamily: "system-ui, -apple-system, sans-serif",
                        letterSpacing: "0.01em",
                        display: "block",
                      }}
                    >
                      שיחה 1
                    </span>
                  </div>
                  <div
                    key={6}
                    onClick={() => getCallsExcel(2)}
                    style={{
                      flex: "1",
                      backgroundColor: "#ffffff",
                      border: "1px solid #e8e8e8",
                      borderRadius: "10px",
                      padding: "18px 24px",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      textAlign: "right",
                      direction: "rtl",
                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#f8f9fa";
                      e.currentTarget.style.borderColor = "#d8d8d8";
                      e.currentTarget.style.boxShadow =
                        "0 2px 6px rgba(0, 0, 0, 0.12)";
                      e.currentTarget.style.transform = "translateY(-1px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#ffffff";
                      e.currentTarget.style.borderColor = "#e8e8e8";
                      e.currentTarget.style.boxShadow =
                        "0 1px 3px rgba(0, 0, 0, 0.08)";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    <span
                      style={{
                        fontSize: "15px",
                        fontWeight: "400",
                        color: "#2c3e50",
                        fontFamily: "system-ui, -apple-system, sans-serif",
                        letterSpacing: "0.01em",
                        display: "block",
                      }}
                    >
                      שיחה 2
                    </span>
                  </div>
                </div>,
                <div
                  key="calls-row-2"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    key={7}
                    onClick={() => getCallsExcel(3)}
                    style={{
                      flex: "1",
                      backgroundColor: "#ffffff",
                      border: "1px solid #e8e8e8",
                      borderRadius: "10px",
                      padding: "18px 24px",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      textAlign: "right",
                      direction: "rtl",
                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#f8f9fa";
                      e.currentTarget.style.borderColor = "#d8d8d8";
                      e.currentTarget.style.boxShadow =
                        "0 2px 6px rgba(0, 0, 0, 0.12)";
                      e.currentTarget.style.transform = "translateY(-1px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#ffffff";
                      e.currentTarget.style.borderColor = "#e8e8e8";
                      e.currentTarget.style.boxShadow =
                        "0 1px 3px rgba(0, 0, 0, 0.08)";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    <span
                      style={{
                        fontSize: "15px",
                        fontWeight: "400",
                        color: "#2c3e50",
                        fontFamily: "system-ui, -apple-system, sans-serif",
                        letterSpacing: "0.01em",
                        display: "block",
                      }}
                    >
                      שיחה 3
                    </span>
                  </div>
                  <div
                    key={8}
                    onClick={() => getCallsExcel(4)}
                    style={{
                      flex: "1",
                      backgroundColor: "#ffffff",
                      border: "1px solid #e8e8e8",
                      borderRadius: "10px",
                      padding: "18px 24px",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      textAlign: "right",
                      direction: "rtl",
                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#f8f9fa";
                      e.currentTarget.style.borderColor = "#d8d8d8";
                      e.currentTarget.style.boxShadow =
                        "0 2px 6px rgba(0, 0, 0, 0.12)";
                      e.currentTarget.style.transform = "translateY(-1px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#ffffff";
                      e.currentTarget.style.borderColor = "#e8e8e8";
                      e.currentTarget.style.boxShadow =
                        "0 1px 3px rgba(0, 0, 0, 0.08)";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    <span
                      style={{
                        fontSize: "15px",
                        fontWeight: "400",
                        color: "#2c3e50",
                        fontFamily: "system-ui, -apple-system, sans-serif",
                        letterSpacing: "0.01em",
                        display: "block",
                      }}
                    >
                      שיחה 4
                    </span>
                  </div>
                </div>,
              ]}
            />
          }
        />
      )}
      {showIplanModal && (
        <GenericModal
          init={setShowIplanModal}
          div={
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                maxWidth: "360px",
                margin: "0 16px",
                padding: "22px 18px 18px",
                background: "linear-gradient(180deg, #ffffff 0%, #f5f8fc 100%)",
                border: "2px solid #7a9abf",
                borderRadius: "16px",
                boxShadow:
                  "0 16px 48px rgba(15, 40, 70, 0.22), 0 0 0 1px rgba(255,255,255,0.6) inset",
              }}
            >
              <MediumFont
                style={{
                  fontWeight: 600,
                  marginBottom: 14,
                  fontSize: 18,
                  color: "#1e3a5f",
                }}
              >
                אייפלאן
              </MediumFont>
              <ToolsOptions
                compact
                data={[
                  <TextWithPic
                    key="iplan-export"
                    onClick={() => {
                      setShowIplanModal(false);
                      getWeddingInvitationsTemplateExcel();
                    }}
                  >
                    יצוא לאייפלאן
                  </TextWithPic>,
                  <TextWithPic
                    key="iplan-compare"
                    onClick={() => {
                      setShowIplanModal(false);
                      setWeddingCompareLines([]);
                      setWeddingCompareNewGuests([]);
                      setShowWeddingCompareModal(true);
                    }}
                  >
                    השוואה לקובץ ייצוא קודם
                  </TextWithPic>,
                ]}
              />
            </div>
          }
        />
      )}
      {showWeddingCompareModal && (
        <GenericModal
          init={setShowWeddingCompareModal}
          div={
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                maxWidth: "420px",
                padding: "32px 24px",
                gap: "16px",
                backgroundColor: "#fff",
                borderRadius: "12px",
                direction: "rtl",
                boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
              }}
            >
              <MediumFont style={{ fontWeight: 600, marginBottom: 4 }}>
                השוואה לקובץ ייצוא (אייפלאן)
              </MediumFont>
              <Label
                style={{
                  margin: 0,
                  textAlign: "center",
                  fontSize: 13,
                  color: "#555",
                  lineHeight: 1.45,
                }}
              >
                בחרו את הקובץ שהורדתם לפני כמה ימים ונציג לכם מה השתנה מאז על
                מנת שתוכלו לעדכן באייפלאן
              </Label>
              <input
                ref={weddingCompareFileInputRef}
                type="file"
                hidden
                accept=".xlsx,.xls,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                onChange={handleWeddingCompareFile}
              />
              <TextWithPic
                onClick={() => weddingCompareFileInputRef.current?.click()}
              >
                בחירת קובץ
              </TextWithPic>
              {weddingCompareLines.length > 0 && (
                <>
                  <Label
                    style={{ margin: 0, alignSelf: "end", fontWeight: 600 }}
                  >
                    שינויים בעמודת האישור:
                  </Label>
                  <pre
                    style={{
                      width: "100%",
                      maxHeight: "220px",
                      overflow: "auto",
                      margin: 0,
                      padding: "12px",
                      background: "#f8f9fa",
                      borderRadius: 8,
                      fontSize: 13,
                      whiteSpace: "pre-wrap",
                      textAlign: "right",
                      direction: "rtl",
                      border: "1px solid #e8e8e8",
                    }}
                  >
                    {weddingCompareLines.join("\n")}
                  </pre>
                </>
              )}
              {weddingCompareNewGuests.length > 0 && (
                <div style={{ width: "100%" }}>
                  <TextWithPic onClick={downloadWeddingNewSinceExport}>
                    אורחים נוספים שאישרו מאז ({weddingCompareNewGuests.length})
                    — הורדה
                  </TextWithPic>
                </div>
              )}
              <TextWithPic onClick={() => setShowWeddingCompareModal(false)}>
                סגור
              </TextWithPic>
            </div>
          }
        />
      )}
      {showAddManually && (
        <GenericModal
          init={selfInit}
          div={
            <AddManually
              acceptLimit={user.acceptLimit}
              init={selfInit}
              categories={categories}
            />
          }
        />
      )}
      {showAddIphone && (
        <GenericModal
          init={selfInit}
          div={
            <AddIphone
              acceptLimit={user.acceptLimit}
              categories={categories}
              phones={phones}
              init={selfInit}
            />
          }
        />
      )}
      {showList && (
        <GenericModal
          init={selfInit}
          div={
            <AddList
              acceptLimit={user.acceptLimit}
              categories={categories}
              phones={phones}
              init={selfInit}
            />
          }
        />
      )}
      {showAddAndroid && (
        <GenericModal
          init={selfInit}
          div={
            <AddAndroid
              acceptLimit={user.acceptLimit}
              categories={categories}
              phones={phones}
              init={selfInit}
            />
          }
        />
      )}
      {showAddExcel && (
        <GenericModal init={selfInit} div={<AddExcel init={selfInit} />} />
      )}
      {showEditGuest && (
        <GenericModal
          init={setShowEditGuest}
          div={
            <Edit
              guest={showEditGuest}
              categories={categories}
              init={setShowEditGuest}
              handleGetAll={handleGetAll}
            />
          }
        />
      )}
      {showWasInvited && (
        <GenericModal
          init={setShowWasInvited}
          div={<WasInvited func={handleEditMany} init={setShowWasInvited} />}
        />
      )}
      {showTablesChange && (
        <GenericModal
          init={setShowTablesChange}
          div={<Tables func={handleEditMany} init={setShowTablesChange} />}
        />
      )}
      {showtables && (
        <GenericModal
          init={setShowtables}
          div={
            <MainTables
              init={setShowtables}
              handleGetAll={handleGetAll}
              guestsLoading={guestsLoading}
            />
          }
        />
      )}
      {showDayalim && (
        <GenericModal
          init={setShowDayalim}
          div={<Dayalim init={setShowDayalim} guestsLoading={guestsLoading} />}
        />
      )}
      {showClosenessChange && (
        <GenericModal
          init={setShowClosenessChange}
          div={
            <Closeness func={handleEditMany} init={setShowClosenessChange} />
          }
        />
      )}
      {showSupportModal && (
        <GenericModal
          init={setShowSupportModal}
          div={<Support uPphone={user.phone} sP={user.pPhone} />}
        />
      )}
      {showBalancesModal && (
        <GenericModal
          init={() => {
            setShowBalancesModal(false);
            setExpandSmsPurchase(false);
            setExpandWhaPurchase(false);
            setSmsPurchaseQty(0);
            setWhaPurchaseQty(0);
          }}
          div={
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                padding: "24px",
                direction: "rtl",
                textAlign: "right",
                minWidth: 320,
                background: "#ffffff",
                borderRadius: 12,
                boxShadow:
                  "0 8px 32px rgba(0, 0, 0, 0.15), 0 2px 8px rgba(0, 0, 0, 0.08)",
              }}
            >
              <h2
                style={{
                  margin: "0 0 24px",
                  fontSize: "22px",
                  fontWeight: 700,
                }}
              >
                יתרות
              </h2>
              <div style={{ marginBottom: 20 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: 8,
                  }}
                >
                  <span>
                    <img
                      src={sms}
                      alt=""
                      style={{
                        width: 18,
                        height: 18,
                        verticalAlign: "middle",
                        marginLeft: 6,
                      }}
                    />
                    יתרת סמס: <strong>{user?.smsBalance ?? 0}</strong>
                  </span>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      setExpandSmsPurchase((p) => !p);
                    }}
                    style={{
                      padding: "6px 12px",
                      borderRadius: 8,
                      border: "1px solid #B8A86A",
                      background: "#B8A86A",
                      color: "#fff",
                      cursor: "pointer",
                      fontSize: 14,
                    }}
                  >
                    רכשו עוד
                  </button>
                </div>
                {expandSmsPurchase && (
                  <div
                    style={{
                      marginTop: 12,
                      padding: 12,
                      background: "#f9f9f9",
                      borderRadius: 8,
                    }}
                  >
                    <div style={{ marginBottom: 8, fontSize: 14 }}>כמות:</div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 10,
                        flexWrap: "wrap",
                        marginBottom: 12,
                        direction: "rtl",
                      }}
                    >
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSmsPurchaseQty((q) => q + 50);
                        }}
                        style={qtyBtnStyle}
                      >
                        50+
                      </button>
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSmsPurchaseQty((q) => q + 10);
                        }}
                        style={qtyBtnStyle}
                      >
                        10+
                      </button>
                      <span
                        style={{
                          minWidth: 48,
                          textAlign: "center",
                          fontWeight: 700,
                          fontSize: 15,
                          margin: "0 2px",
                        }}
                      >
                        {smsPurchaseQty}
                      </span>
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSmsPurchaseQty((q) => Math.max(0, q - 10));
                        }}
                        style={qtyBtnStyle}
                      >
                        10-
                      </button>
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSmsPurchaseQty((q) => Math.max(0, q - 50));
                        }}
                        style={qtyBtnStyle}
                      >
                        50-
                      </button>
                    </div>
                    <div style={{ fontSize: 14, fontWeight: 600 }}>
                      עלות: {((smsPurchaseQty * SMS_AGOROT) / 100).toFixed(2)} ₪
                    </div>
                  </div>
                )}
              </div>
              <div style={{ marginBottom: 24 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: 8,
                  }}
                >
                  <span>
                    <img
                      src={whatsapp}
                      alt=""
                      style={{
                        width: 22,
                        height: 22,
                        verticalAlign: "middle",
                        marginLeft: 6,
                      }}
                    />
                    יתרת וואטסאפ: <strong>{user?.whaBalance ?? 0}</strong>
                  </span>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      setExpandWhaPurchase((p) => !p);
                    }}
                    style={{
                      padding: "6px 12px",
                      borderRadius: 8,
                      border: "1px solid #6B8E5C",
                      background: "#6B8E5C",
                      color: "#fff",
                      cursor: "pointer",
                      fontSize: 14,
                    }}
                  >
                    רכשו עוד
                  </button>
                </div>
                {expandWhaPurchase && (
                  <div
                    style={{
                      marginTop: 12,
                      padding: 12,
                      background: "#f9f9f9",
                      borderRadius: 8,
                    }}
                  >
                    <div style={{ marginBottom: 8, fontSize: 14 }}>כמות:</div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 10,
                        flexWrap: "wrap",
                        marginBottom: 12,
                        direction: "rtl",
                      }}
                    >
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setWhaPurchaseQty((q) => q + 50);
                        }}
                        style={qtyBtnStyle}
                      >
                        50+
                      </button>
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setWhaPurchaseQty((q) => q + 10);
                        }}
                        style={qtyBtnStyle}
                      >
                        10+
                      </button>
                      <span
                        style={{
                          minWidth: 48,
                          textAlign: "center",
                          fontWeight: 700,
                          fontSize: 15,
                          margin: "0 2px",
                        }}
                      >
                        {whaPurchaseQty}
                      </span>
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setWhaPurchaseQty((q) => Math.max(0, q - 10));
                        }}
                        style={qtyBtnStyle}
                      >
                        10-
                      </button>
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setWhaPurchaseQty((q) => Math.max(0, q - 50));
                        }}
                        style={qtyBtnStyle}
                      >
                        50-
                      </button>
                    </div>
                    <div style={{ fontSize: 14, fontWeight: 600 }}>
                      עלות: {((whaPurchaseQty * WA_AGOROT) / 100).toFixed(2)} ₪
                    </div>
                  </div>
                )}
              </div>
              <button
                type="button"
                onClick={handleProceedToPayment}
                style={{
                  width: "100%",
                  padding: "12px 24px",
                  borderRadius: 8,
                  border: "none",
                  background: "#1e5a8e",
                  color: "#fff",
                  fontSize: 16,
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                מעבר לתשלום
              </button>
            </div>
          }
        />
      )}
      {showMisModal && (
        <GenericModal
          init={setShowMisModal}
          div={<Mis data={guestsArray[2]} />}
        />
      )}
      {showOwcChange && (
        <GenericModal
          init={setShowOwcChange}
          div={
            user.eventType ? (
              <Connection func={handleEditMany} init={setShowOwcChange} />
            ) : (
              <ConnectionOtherEvent
                func={handleEditMany}
                init={setShowOwcChange}
              />
            )
          }
        />
      )}
      {showGifts && (
        <GenericModal init={setShowGifts} div={<Gifts init={setShowGifts} />} />
      )}
      {showDelete && (
        <GenericModal
          init={setShowDelete}
          div={
            <YesNoModal
              title={"מחיקת רשומות"}
              body={"האם את/ה בטוח/ה שברצונך למחוק רשומות אלה?"}
              no={setShowDelete}
              yes={handleDeleteMany}
            />
          }
        />
      )}
      {showSendMessageModal && (
        <GenericModal
          init={() => {
            setShowSendMessageModal(false);
            setSendMessageContent("");
          }}
          div={
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                padding: "20px",
                minWidth: "320px",
                maxWidth: "90vw",
                direction: "rtl",
                fontFamily: "inherit",
                backgroundColor: "#fff",
                borderRadius: "12px",
                border: `1px solid ${addAlpha("#7b96c4", 0.3)}`,
                boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
              }}
            >
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "600",
                  marginBottom: "12px",
                  color: "#333",
                }}
              >
                שליחת הודעה לאורחים שנבחרו
              </div>
              <div
                style={{
                  fontSize: "13px",
                  color: "#555",
                  marginBottom: "10px",
                  lineHeight: 1.45,
                }}
              >
                {isGuestBulkSmsBlocked ? (
                  <span style={{ color: "#c62828" }}>
                    עברת את המגבלה של 2 הודעות כלליות.
                  </span>
                ) : (
                  <>
                    נותרו{" "}
                    <strong>{FREE_GUEST_SMS_LIMIT - freeSmsUsedCount}</strong>{" "}
                    שליחות מתוך {FREE_GUEST_SMS_LIMIT} (לפי מסך זה בלבד).
                  </>
                )}
              </div>
              <textarea
                value={sendMessageContent}
                onChange={(e) => setSendMessageContent(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                placeholder="הזינו את תוכן ההודעה..."
                style={{
                  width: "100%",
                  minHeight: "100px",
                  padding: "10px",
                  borderRadius: "8px",
                  border: `2px solid ${addAlpha("#7b96c4", 0.4)}`,
                  fontSize: "14px",
                  resize: "vertical",
                  outline: "none",
                  fontFamily: "inherit",
                  marginBottom: "12px",
                  boxSizing: "border-box",
                }}
              />
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  justifyContent: "flex-start",
                }}
              >
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSendMessageToSelected();
                  }}
                  style={{
                    padding: "8px 16px",
                    borderRadius: "6px",
                    border: "none",
                    backgroundColor: isGuestBulkSmsBlocked
                      ? "#bdbdbd"
                      : "#7b96c4",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "500",
                    cursor: isGuestBulkSmsBlocked ? "not-allowed" : "pointer",
                    opacity: isGuestBulkSmsBlocked ? 0.85 : 1,
                  }}
                >
                  שליחה
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowSendMessageModal(false);
                    setSendMessageContent("");
                  }}
                  style={{
                    padding: "8px 16px",
                    borderRadius: "6px",
                    border: "1px solid #e0e0e0",
                    backgroundColor: "#fff",
                    color: "#333",
                    fontSize: "14px",
                    cursor: "pointer",
                  }}
                >
                  ביטול
                </button>
              </div>
            </div>
          }
        />
      )}
      {canSeeUnpaidGuestsNotice && showSystemNoticeModal && (
        <GenericModal
          init={() => {
            setShowSystemNoticeModal(false);
            setSystemPaymentLink("");
            setShowUnpaidGuestsList(false);
          }}
          div={
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                padding: "20px",
                minWidth: "320px",
                maxWidth: "90vw",
                direction: "rtl",
                backgroundColor: "#fff",
                borderRadius: "12px",
                border: "1px solid #f3c7c7",
                boxShadow: "0 8px 30px rgba(0,0,0,0.14)",
              }}
            >
              <div
                style={{
                  fontSize: "17px",
                  fontWeight: 700,
                  marginBottom: "10px",
                  color: "#b71c1c",
                }}
              >
                הודעת מערכת
              </div>
              <div style={{ fontSize: "14px", lineHeight: 1.6, color: "#333" }}>
                קיימים {unpaidGuestsCount} אורחים שלא שולמו ולא יקבלו את תהליך
                אישורי ההגעה.
              </div>
              <div
                style={{
                  marginTop: "12px",
                  fontSize: "14px",
                  fontWeight: 600,
                  color: "#1a237e",
                  textAlign: "right",
                  lineHeight: 1.5,
                }}
              >
                {unpaidGuestsCount} רשומות כפול {user?.deal ?? 0} לרשומה ={" "}
                {parseFloat(Number(user?.deal ?? 0) * unpaidGuestsCount)}
              </div>
              <button
                type="button"
                onClick={handleProceedToPayment}
                disabled={creatingSystemPaymentLink}
                style={{
                  marginTop: "16px",
                  width: "100%",
                  padding: "10px 12px",
                  borderRadius: "8px",
                  border: "none",
                  backgroundColor: "#7b96c4",
                  color: "#fff",
                  fontSize: "15px",
                  fontWeight: 600,
                  cursor: creatingSystemPaymentLink ? "wait" : "pointer",
                  opacity: creatingSystemPaymentLink ? 0.85 : 1,
                }}
              >
                {creatingSystemPaymentLink ? "מייצר קישור..." : "לתשלום"}
              </button>
              <button
                type="button"
                onClick={() => setShowUnpaidGuestsList((prev) => !prev)}
                style={{
                  marginTop: "10px",
                  width: "100%",
                  padding: "10px 12px",
                  borderRadius: "8px",
                  border: "1px solid #7b96c4",
                  backgroundColor: "#fff",
                  color: "#2f4d7a",
                  fontSize: "15px",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                {showUnpaidGuestsList ? "הסתרת האורחים" : "הצגת האורחים"}
              </button>
              {showUnpaidGuestsList && (
                <div
                  style={{
                    marginTop: "10px",
                    border: "1px solid #eee",
                    borderRadius: "8px",
                    padding: "8px 10px",
                    backgroundColor: "#fafafa",
                  }}
                >
                  {unpaidGuestsNames.length > 0 ? (
                    <div
                      style={{
                        fontSize: "13px",
                        color: "#333",
                        lineHeight: 1.6,
                        textAlign: "right",
                      }}
                    >
                      {unpaidGuestsNames.join(", ")}
                    </div>
                  ) : (
                    <div style={{ fontSize: "13px", color: "#777" }}>
                      לא נמצאו אורחים להצגה.
                    </div>
                  )}
                </div>
              )}
              {systemPaymentLink ? (
                <div style={{ marginTop: "14px" }}>
                  <div
                    style={{
                      marginTop: "14px",
                      fontWeight: "bold",
                      color: "red",
                      fontSize: "14px",
                    }}
                  >
                    לא מכבדים דיינרס ואמריקן אקפרס
                  </div>
                  <iframe
                    src={systemPaymentLink}
                    title="תשלום"
                    style={{
                      width: "100%",
                      height: "420px",
                      border: "1px solid #e0e0e0",
                      borderRadius: "8px",
                      background: "#fff",
                    }}
                  />
                </div>
              ) : null}
            </div>
          }
        />
      )}
      <style>
        {`
          @keyframes systemNoticeBlink {
            0%, 100% { opacity: 1; transform: scale(1); }
            50% { opacity: 0.55; transform: scale(1.02); }
          }
        `}
      </style>

      {showHadrahot && (
        <GenericModal
          init={setShowHadrahot}
          div={<CanWeStart init={setShowHadrahot} />}
        />
      )}
      {showLogout && (
        <GenericModal
          init={setShowLogout}
          div={<LogoutSpecipic init={setShowLogout} />}
        />
      )}
      {showIsReadyConfirm && (
        <GenericModal
          init={() => {
            setShowIsReadyConfirm(false);
          }}
          div={
            <YesNoModal
              title="שינוי מצב אירוע"
              body={
                "האם להפסיק את האירוע?\nפעולה זו תבטל את כל תזמוני ההודעות מהיום (כולל) ואילך, ותאפס שיוך השיחות לטלפנית"
              }
              no={() => {
                setShowIsReadyConfirm(false);
              }}
              yes={() => {
                dispatch(deactivateEvent()).then(() => {
                  toast.success("הפעולה בוצעה בהצלחה");
                  setShowIsReadyConfirm(false);
                });
              }}
            />
          }
        />
      )}
    </div>
  );
};

export default MainUser;
